<ion-item 
    lines="none"
    (click)="openPicker()" 
    [ngClass]="{'liveUpdate': isLiveUpdating, 'ion-text-center': !hasLabel}"
>
    <ion-label class="keepLeft showOverflow" *ngIf="hasLabel" [position]="position">{{label}}</ion-label>
    <ion-label class="result" [ngClass]="{'keepLeft': isStacked}">{{templateValue}}</ion-label>
</ion-item>